module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.66e7ace8.mp3";